import { render, staticRenderFns } from "./NewPasswordDialog.vue?vue&type=template&id=4dcfa2ee&"
import script from "./NewPasswordDialog.vue?vue&type=script&lang=js&"
export * from "./NewPasswordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewPasswordDialog.vue"
export default component.exports